instant.ribbonModalList = {
  open: function (key) {
    var targetModal = document.getElementById(`modal-${key}`);

    targetModal.showModal();
    targetModal.addEventListener('click', () => targetModal.close(), { once: true });
    targetModal.querySelector('.modalContent').addEventListener('click', (e) => e.stopPropagation());
  },
  close: function (key) {
    var targetModal = document.getElementById(`modal-${key}`);
    targetModal.close();
    targetModal.querySelector('.modalContent').removeEventListener('click', (e) => e.stopPropagation());
  },
  contentClickHandler: function (e) {
    e.stopPropagation();
  }
};